// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1__c73e1bdcca822f3b3af0{/*!*/}.common-cls2___d1489f14313fc25c004{width:63px;height:68px}.common-cls2___d1489f14313fc25c004 svg{width:inherit;height:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1__c73e1bdcca822f3b3af0",
	"cls2": "common-cls2___d1489f14313fc25c004 common-cls1__c73e1bdcca822f3b3af0"
};
export default ___CSS_LOADER_EXPORT___;
